import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";

const InternshipsPage = () => {
  const [internships] = useState([
    // Technology & Development Internships
    {
      id: 1,
      title: "Full Stack Development Intern",
      department: "Technology",
      location: "Remote/On-site",
      duration: "3-6 months",
      stipend: "10,000 - 25,000/month",
      type: "Paid",
      program: "Regular Internship",
      description: "Learn modern web development technologies while working on real projects. Build scalable applications using React, Node.js, and cloud technologies.",
      skills: ["React", "Node.js", "JavaScript", "Git", "REST APIs"],
      requirements: "Computer Science/IT student, Basic programming knowledge",
      spots: 10
    },
    {
      id: 2,
      title: "AI & Machine Learning Research Intern",
      department: "Center of Excellence",
      location: "Hybrid",
      duration: "6 months",
      stipend: "15000 - 20,000/month",
      type: "Paid Research",
      program: "AI-Driven Innovation",
      description: "Join our Center of Excellence to research cutting-edge AI technologies. Work on neural networks, deep learning, and contribute to published research.",
      skills: ["Python", "TensorFlow", "Research Methods", "Statistics", "Mathematics"],
      requirements: "CS/Data Science student, Strong mathematical background",
      spots: 5
    },
    {
      id: 3,
      title: "Data Science & Analytics Intern",
      department: "Data & AI",
      location: "On-site",
      duration: "4 months",
      stipend: "10000 - 15000/month",
      type: "Paid",
      program: "AI-Driven Innovation",
      description: "Analyze large datasets and build predictive models. Work with real business data to derive actionable insights using advanced analytics techniques.",
      skills: ["Python", "SQL", "Pandas", "Visualization", "Statistics"],
      requirements: "Statistics/Math/CS student, Analytical mindset",
      spots: 8
    },
    {
      id: 4,
      title: "Cloud Computing Research Intern",
      department: "Center of Excellence",
      location: "Hybrid",
      duration: "6 months",
      stipend: "$300 - $700/month",
      type: "Paid Research",
      program: "AI-Driven Innovation",
      description: "Research cloud-native architectures and serverless computing. Contribute to open-source projects and develop innovative cloud solutions.",
      skills: ["AWS/Azure", "Kubernetes", "Docker", "Microservices", "DevOps"],
      requirements: "CS/Engineering student, Cloud platform knowledge preferred",
      spots: 6
    },
    {
      id: 5,
      title: "Quantum Computing Research Intern",
      department: "Center of Excellence",
      location: "On-site",
      duration: "6 months",
      stipend: "$2,000 - $2,500/month",
      type: "Paid Research",
      program: "AI-Driven Innovation",
      description: "Explore quantum algorithms and quantum machine learning. Work with quantum simulators and contribute to quantum computing research papers.",
      skills: ["Quantum Mechanics", "Python", "Qiskit", "Linear Algebra", "Physics"],
      requirements: "Physics/CS PhD student, Quantum mechanics background",
      spots: 3
    },
    {
      id: 6,
      title: "Embedded Systems & IoT Intern",
      department: "Engineering",
      location: "On-site",
      duration: "4 months",
      stipend: "$900 - $1,300/month",
      type: "Paid",
      program: "Regular Internship",
      description: "Design and develop IoT devices and embedded systems. Work on sensor integration, real-time systems, and edge computing solutions.",
      skills: ["C/C++", "Arduino", "Raspberry Pi", "Sensors", "Embedded Linux"],
      requirements: "ECE/EE student, Hardware programming experience",
      spots: 7
    },
    {
      id: 7,
      title: "Robotics & Automation Intern",
      department: "Engineering",
      location: "On-site",
      duration: "5 months",
      stipend: "$1,100 - $1,500/month",
      type: "Paid",
      program: "AI-Driven Innovation",
      description: "Develop robotic systems and automation solutions. Work on computer vision, path planning, and autonomous navigation systems.",
      skills: ["ROS", "Python", "Computer Vision", "Control Systems", "MATLAB"],
      requirements: "Robotics/ME/ECE student, Basic robotics knowledge",
      spots: 5
    },
    {
      id: 8,
      title: "Cybersecurity Research Intern",
      department: "Center of Excellence",
      location: "Hybrid",
      duration: "4-6 months",
      stipend: "$1,200 - $1,600/month",
      type: "Paid Research",
      program: "AI-Driven Innovation",
      description: "Research AI-powered cybersecurity solutions. Work on threat detection, security analytics, and develop innovative security frameworks.",
      skills: ["Network Security", "Python", "Machine Learning", "Penetration Testing", "Cryptography"],
      requirements: "CS/Cybersecurity student, Security fundamentals knowledge",
      spots: 6
    },
    {
      id: 9,
      title: "Business Intelligence Intern",
      department: "Business",
      location: "Remote",
      duration: "3 months",
      stipend: "$700 - $1,000/month",
      type: "Paid",
      program: "Regular Internship",
      description: "Create business dashboards and analytics solutions. Work with stakeholders to understand requirements and deliver data-driven insights.",
      skills: ["Tableau", "Power BI", "SQL", "Excel", "Business Analysis"],
      requirements: "Business/Economics student, Analytical skills",
      spots: 8
    },
    {
      id: 10,
      title: "Geospatial Technology Intern",
      department: "Engineering",
      location: "On-site",
      duration: "4 months",
      stipend: "$800 - $1,200/month",
      type: "Paid",
      program: "Regular Internship",
      description: "Work with GIS technologies and spatial data analysis. Support geological and environmental projects with geospatial solutions.",
      skills: ["GIS", "Remote Sensing", "Python", "ArcGIS", "Spatial Analysis"],
      requirements: "Geography/Geology/Environmental student, GIS basics",
      spots: 6
    },
    {
      id: 11,
      title: "Renewable Energy Research Intern",
      department: "Center of Excellence",
      location: "Hybrid",
      duration: "6 months",
      stipend: "$1,400 - $1,800/month",
      type: "Paid Research",
      program: "AI-Driven Innovation",
      description: "Research AI applications in renewable energy systems. Optimize energy storage, grid integration, and predictive maintenance solutions.",
      skills: ["Energy Systems", "Python", "Simulation", "Data Analysis", "Optimization"],
      requirements: "Engineering/Environmental student, Renewable energy interest",
      spots: 4
    },
    {
      id: 12,
      title: "SAP Technology Intern",
      department: "Technology",
      location: "On-site",
      duration: "4 months",
      stipend: "$1,000 - $1,300/month",
      type: "Paid",
      program: "Regular Internship",
      description: "Learn SAP technologies and enterprise solutions. Work on SAP implementations, customizations, and integration projects.",
      skills: ["SAP", "ABAP", "Database", "Business Processes", "ERP"],
      requirements: "IT/CS student, Interest in enterprise software",
      spots: 7
    },
    {
      id: 13,
      title: "EdTech Content Development Intern",
      department: "Education",
      location: "Remote",
      duration: "3-4 months",
      stipend: "$600 - $900/month",
      type: "Paid",
      program: "Regular Internship",
      description: "Create engaging educational content and learning experiences. Develop interactive courseware and educational technology solutions.",
      skills: ["Content Creation", "Learning Design", "Video Editing", "Writing", "LMS"],
      requirements: "Education/Communications student, Creative skills",
      spots: 10
    },
    {
      id: 14,
      title: "Natural Language Processing Intern",
      department: "Center of Excellence",
      location: "Hybrid",
      duration: "6 months",
      stipend: "$1,600 - $2,200/month",
      type: "Paid Research",
      program: "AI-Driven Innovation",
      description: "Research advanced NLP techniques and large language models. Work on conversational AI, text analysis, and language understanding systems.",
      skills: ["NLP", "Transformers", "Python", "Deep Learning", "Linguistics"],
      requirements: "CS/Linguistics student, NLP background preferred",
      spots: 4
    },
    {
      id: 15,
      title: "Computer Vision Research Intern",
      department: "Center of Excellence",
      location: "On-site",
      duration: "6 months",
      stipend: "$1,500 - $2,000/month",
      type: "Paid Research",
      program: "AI-Driven Innovation",
      description: "Develop computer vision algorithms for real-world applications. Work on object detection, image segmentation, and visual AI systems.",
      skills: ["OpenCV", "Deep Learning", "Python", "Image Processing", "CNN"],
      requirements: "CS/EE student, Computer vision fundamentals",
      spots: 5
    },
    {
      id: 16,
      title: "Mobile App Development Intern",
      department: "Technology",
      location: "Hybrid",
      duration: "4 months",
      stipend: "$900 - $1,300/month",
      type: "Paid",
      program: "Regular Internship",
      description: "Develop cross-platform mobile applications using React Native and Flutter. Work on user experience design and mobile app optimization.",
      skills: ["React Native", "Flutter", "JavaScript", "Mobile UI/UX", "Firebase"],
      requirements: "CS/IT student, Mobile development interest",
      spots: 6
    },
    {
      id: 17,
      title: "DevOps & Infrastructure Intern",
      department: "Technology",
      location: "On-site",
      duration: "5 months",
      stipend: "$1,000 - $1,400/month",
      type: "Paid",
      program: "Regular Internship",
      description: "Learn DevOps practices and cloud infrastructure management. Work with CI/CD pipelines, containerization, and monitoring systems.",
      skills: ["Docker", "Kubernetes", "Jenkins", "AWS", "Linux", "Monitoring"],
      requirements: "CS/Engineering student, Basic system administration knowledge",
      spots: 5
    },
    {
      id: 18,
      title: "UX/UI Design Intern",
      department: "Design",
      location: "Hybrid",
      duration: "3-4 months",
      stipend: "$700 - $1,100/month",
      type: "Paid",
      program: "Regular Internship",
      description: "Design user interfaces and experiences for web and mobile applications. Conduct user research and create design prototypes.",
      skills: ["Figma", "Adobe XD", "User Research", "Prototyping", "Design Systems"],
      requirements: "Design/HCI student, Portfolio required",
      spots: 4
    },
    {
      id: 19,
      title: "Blockchain Development Intern",
      department: "Center of Excellence",
      location: "On-site",
      duration: "6 months",
      stipend: "$1,300 - $1,800/month",
      type: "Paid Research",
      program: "AI-Driven Innovation",
      description: "Research blockchain technologies and develop decentralized applications. Work on smart contracts, DeFi protocols, and Web3 solutions.",
      skills: ["Solidity", "Ethereum", "Web3", "Smart Contracts", "JavaScript"],
      requirements: "CS student, Cryptocurrency/blockchain knowledge",
      spots: 3
    },
    {
      id: 20,
      title: "Digital Marketing & Analytics Intern",
      department: "Marketing",
      location: "Remote",
      duration: "3 months",
      stipend: "$600 - $900/month",
      type: "Paid",
      program: "Regular Internship",
      description: "Develop digital marketing strategies and analyze campaign performance. Work with social media, content marketing, and SEO optimization.",
      skills: ["Google Analytics", "SEO", "Social Media", "Content Marketing", "PPC"],
      requirements: "Marketing/Communications student, Digital marketing interest",
      spots: 5
    }
  ]);

  const [filteredInternships, setFilteredInternships] = useState(internships);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedProgram, setSelectedProgram] = useState('all');
  const [selectedDepartment, setSelectedDepartment] = useState('all');
  const [selectedLocation, setSelectedLocation] = useState('all');
  const [showApplicationModal, setShowApplicationModal] = useState(false);
  const [selectedInternship, setSelectedInternship] = useState(null);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [applicationForm, setApplicationForm] = useState({
    fullName: '',
    email: '',
    phone: '',
    university: '',
    major: '',
    yearOfStudy: '',
    gpa: '',
    coverLetter: '',
    resume: null,
    portfolio: '',
    linkedin: '',
    skills: '',
    experience: ''
  });

  useEffect(() => {
    filterInternships();
  }, [searchTerm, selectedProgram, selectedDepartment, selectedLocation]);

  const filterInternships = () => {
    let filtered = internships;

    if (searchTerm) {
      filtered = filtered.filter(internship =>
        internship.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
        internship.department.toLowerCase().includes(searchTerm.toLowerCase()) ||
        internship.skills.some(skill => skill.toLowerCase().includes(searchTerm.toLowerCase())) ||
        internship.description.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    if (selectedProgram !== 'all') {
      filtered = filtered.filter(internship => internship.program === selectedProgram);
    }

    if (selectedDepartment !== 'all') {
      filtered = filtered.filter(internship => internship.department === selectedDepartment);
    }

    if (selectedLocation !== 'all') {
      filtered = filtered.filter(internship => internship.location === selectedLocation);
    }

    setFilteredInternships(filtered);
  };

  const handleApply = (internship) => {
    setSelectedInternship(internship);
    setShowApplicationModal(true);
  };

  const handleFormChange = (field, value) => {
    setApplicationForm(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const resetForm = () => {
    setApplicationForm({
      fullName: '',
      email: '',
      phone: '',
      university: '',
      major: '',
      yearOfStudy: '',
      gpa: '',
      coverLetter: '',
      resume: null,
      portfolio: '',
      linkedin: '',
      skills: '',
      experience: ''
    });
  };

  const submitApplication = () => {
    // Basic validation
    if (!applicationForm.fullName || !applicationForm.email || !applicationForm.coverLetter) {
      alert('Please fill in all required fields (Name, Email, Cover Letter)');
      return;
    }

    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(applicationForm.email)) {
      alert('Please enter a valid email address');
      return;
    }

    setShowApplicationModal(false);
    setShowSuccessMessage(true);
    resetForm();

    // Auto-hide success message after 5 seconds
    setTimeout(() => {
      setShowSuccessMessage(false);
    }, 5000);
  };

  const styles = {
    body: {
      fontFamily: "'Inter', 'Segoe UI', system-ui, -apple-system, sans-serif",
      background: "linear-gradient(135deg, #ffffffff 0%, #ffffffff 100%)",
      minHeight: "100vh",
      padding: "20px",
      lineHeight: "1.6"
    },
    container: {
      maxWidth: "1400px",
      margin: "0 auto",
      padding: "0 20px"
    },
    heroSection: {
      background: "linear-gradient(135deg, #2563eb 0%, #1e40af 100%)",
      color: "white",
      padding: "80px 40px",
      marginBottom: "40px",
      marginTop:"60px",
      borderRadius: "24px",
      boxShadow: "0 25px 50px rgba(0,0,0,0.15)",
      textAlign: "center",
      position: "relative",
      overflow: "hidden"
    },
    heroTitle: {
      fontSize: "4rem",
      fontWeight: "800",
      marginBottom: "1.5rem",
      textShadow: "2px 2px 4px rgba(0,0,0,0.3)",
      letterSpacing: "-0.02em"
    },
    heroSubtitle: {
      fontSize: "1.4rem",
      fontWeight: "300",
      opacity: "0.95",
      maxWidth: "600px",
      margin: "0 auto"
    },
    statsSection: {
      background: "rgba(255,255,255,0.95)",
      backdropFilter: "blur(20px)",
      borderRadius: "24px",
      padding: "50px 30px",
      marginBottom: "40px",
      boxShadow: "0 20px 40px rgba(0,0,0,0.1)",
      border: "1px solid rgba(255,255,255,0.2)"
    },
    statNumber: {
      fontSize: "3.5rem",
      fontWeight: "800",
      color: "#2563eb",
      display: "block",
      background: "linear-gradient(45deg, #2563eb, #3b82f6)",
      backgroundClip: "text",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent"
    },
    statLabel: {
      color: "#64748b",
      fontWeight: "600",
      marginTop: "12px",
      fontSize: "1.1rem"
    },
    searchContainer: {
      background: "rgba(255,255,255,0.95)",
      backdropFilter: "blur(20px)",
      borderRadius: "24px",
      padding: "40px 30px",
      boxShadow: "0 20px 40px rgba(0,0,0,0.1)",
      marginBottom: "40px",
      border: "1px solid rgba(255,255,255,0.2)"
    },
    searchInput: {
      border: "2px solid #e2e8f0",
      borderRadius: "16px",
      padding: "18px 24px",
      fontSize: "1.1rem",
      width: "100%",
      outline: "none",
      transition: "all 0.3s ease",
      background: "white",
      boxShadow: "0 4px 6px rgba(0,0,0,0.05)"
    },
    filterSelect: {
      border: "2px solid #e2e8f0",
      borderRadius: "16px",
      padding: "18px 24px",
      fontSize: "1.1rem",
      outline: "none",
      transition: "all 0.3s ease",
      width: "100%",
      background: "white",
      boxShadow: "0 4px 6px rgba(0,0,0,0.05)",
      cursor: "pointer"
    },
    programHighlight: {
      background: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
      color: "white",
      padding: "50px 40px",
      borderRadius: "24px",
      marginBottom: "40px",
      boxShadow: "0 25px 50px rgba(16,185,129,0.3)",
      position: "relative",
      overflow: "hidden"
    },
    internshipCard: {
      background: "rgba(255,255,255,0.95)",
      backdropFilter: "blur(20px)",
      borderRadius: "24px",
      padding: "35px",
      boxShadow: "0 15px 35px rgba(0,0,0,0.1)",
      transition: "all 0.4s ease",
      border: "1px solid rgba(255,255,255,0.2)",
      position: "relative",
      marginBottom: "30px",
      overflow: "hidden",
      cursor: "pointer"
    },
    cardHeader: {
      content: "''",
      position: "absolute",
      top: "0",
      left: "0",
      right: "0",
      height: "5px",
      background: "linear-gradient(90deg, #2563eb, #3b82f6, #8b5cf6)"
    },
    internshipTitle: {
      color: "#1f2937",
      fontSize: "1.5rem",
      fontWeight: "700",
      marginBottom: "12px",
      lineHeight: "1.3"
    },
    programBadge: {
      padding: "8px 20px",
      borderRadius: "25px",
      fontSize: "0.9rem",
      fontWeight: "600",
      display: "inline-block",
      marginBottom: "20px",
      textTransform: "uppercase",
      letterSpacing: "0.5px"
    },
    regularBadge: {
      background: "linear-gradient(45deg, #2563eb, #3b82f6)",
      color: "white",
      boxShadow: "0 4px 15px rgba(37, 99, 235, 0.3)"
    },
    researchBadge: {
      background: "linear-gradient(45deg, #10b981, #059669)",
      color: "white",
      boxShadow: "0 4px 15px rgba(16, 185, 129, 0.3)"
    },
    innovationBadge: {
      background: "linear-gradient(45deg, #f59e0b, #d97706)",
      color: "white",
      boxShadow: "0 4px 15px rgba(245, 158, 11, 0.3)"
    },
    detailsGrid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
      gap: "18px",
      marginBottom: "25px"
    },
    detailItem: {
      display: "flex",
      alignItems: "center",
      gap: "12px",
      color: "#64748b",
      fontSize: "0.95rem",
      fontWeight: "500"
    },
    skillTags: {
      display: "flex",
      flexWrap: "wrap",
      gap: "10px",
      marginBottom: "25px"
    },
    skillTag: {
      background: "linear-gradient(45deg, #f1f5f9, #e2e8f0)",
      color: "#475569",
      padding: "6px 16px",
      borderRadius: "20px",
      fontSize: "0.85rem",
      fontWeight: "600",
      border: "1px solid #e2e8f0",
      transition: "all 0.3s ease"
    },
    applyBtn: {
      background: "linear-gradient(45deg, #2563eb, #3b82f6)",
      color: "white",
      border: "none",
      padding: "16px 32px",
      borderRadius: "16px",
      fontWeight: "700",
      cursor: "pointer",
      transition: "all 0.3s ease",
      width: "100%",
      fontSize: "1.1rem",
      textTransform: "uppercase",
      letterSpacing: "0.5px",
      boxShadow: "0 8px 25px rgba(37, 99, 235, 0.3)"
    },
    modal: {
      position: "fixed",
      top: "0",
      left: "0",
      width: "100%",
      height: "100%",
      background: "rgba(0,0,0,0.6)",
      backdropFilter: "blur(8px)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: "1000",
      padding: "20px"
    },
    modalContent: {
      background: "white",
      borderRadius: "24px",
      padding: "50px",
      maxWidth: "700px",
      width: "100%",
      maxHeight: "90vh",
      overflowY: "auto",
      boxShadow: "0 25px 50px rgba(0,0,0,0.3)"
    },
    formGroup: {
      marginBottom: "25px"
    },
    label: {
      display: "block",
      marginBottom: "10px",
      fontWeight: "700",
      color: "#374151",
      fontSize: "1rem"
    },
    formInput: {
      width: "100%",
      padding: "16px 20px",
      border: "2px solid #e5e7eb",
      borderRadius: "12px",
      fontSize: "1rem",
      outline: "none",
      transition: "all 0.3s ease",
      background: "#fafafa",
      boxSizing: "border-box"
    },
    textarea: {
      width: "100%",
      padding: "16px 20px",
      border: "2px solid #e5e7eb",
      borderRadius: "12px",
      fontSize: "1rem",
      outline: "none",
      transition: "all 0.3s ease",
      resize: "vertical",
      minHeight: "120px",
      background: "#fafafa",
      fontFamily: "inherit",
      boxSizing: "border-box"
    },
    submitBtn: {
      background: "linear-gradient(45deg, #10b981, #059669)",
      color: "white",
      border: "none",
      padding: "18px 36px",
      borderRadius: "12px",
      fontWeight: "700",
      cursor: "pointer",
      width: "100%",
      fontSize: "1.1rem",
      textTransform: "uppercase",
      letterSpacing: "0.5px",
      transition: "all 0.3s ease",
      boxShadow: "0 8px 25px rgba(16, 185, 129, 0.3)"
    },
    cancelBtn: {
      background: "#f3f4f6",
      color: "#374151",
      border: "none",
      padding: "18px 36px",
      borderRadius: "12px",
      fontWeight: "700",
      cursor: "pointer",
      width: "100%",
      fontSize: "1.1rem",
      marginRight: "15px",
      transition: "all 0.3s ease"
    },
    successMessage: {
      position: "fixed",
      top: "30px",
      right: "30px",
      background: "linear-gradient(45deg, #10b981, #059669)",
      color: "white",
      padding: "20px 30px",
      borderRadius: "16px",
      boxShadow: "0 15px 35px rgba(16, 185, 129, 0.3)",
      zIndex: "1001",
      minWidth: "350px",
      animation: "slideIn 0.5s ease-out"
    },
    filterBadge: {
      background: "linear-gradient(45deg, #8b5cf6, #7c3aed)",
      color: "white",
      padding: "8px 16px",
      borderRadius: "20px",
      fontSize: "0.8rem",
      fontWeight: "600",
      display: "inline-block",
      margin: "5px"
    }
  };

  const getProgramBadgeStyle = (program) => {
    if (program === "AI-Driven Innovation") {
      return { ...styles.programBadge, ...styles.innovationBadge };
    } else if (program === "Paid Research") {
      return { ...styles.programBadge, ...styles.researchBadge };
    }
    return { ...styles.programBadge, ...styles.regularBadge };
  };

  const totalStipends = internships.reduce((sum, intern) => {
    const maxStipend = parseInt(intern.stipend.split(' - ')[1].replace(/[^0-9]/g, ''));
    return sum + maxStipend;
  }, 0);

  const uniqueDepartments = [...new Set(internships.map(intern => intern.department))];
  const uniqueLocations = [...new Set(internships.map(intern => intern.location))];

  return (
    <div style={styles.body}>
      {/* Success Message */}
      {showSuccessMessage && (
        <div style={styles.successMessage}>
          <h4 style={{ margin: "0 0 10px 0", fontSize: "1.2rem" }}>✅ Application Submitted!</h4>
          <p style={{ margin: "0", opacity: "0.9" }}>
            Your application for <strong>{selectedInternship?.title}</strong> has been submitted successfully. 
            We'll review it and get back to you soon!
          </p>
        </div>
      )}

      <div style={styles.container}>
        {/* Hero Section */}
        <div style={styles.heroSection}>
          <h1 style={styles.heroTitle}>Internship Opportunities</h1>
          <p style={styles.heroSubtitle}>
            Launch your career with cutting-edge technology internships and research programs. 
            Join innovative teams and work on projects that shape the future.
          </p>
        </div>

        {/* Stats Section */}
        <div style={styles.statsSection}>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))", gap: "30px", textAlign: "center" }}>
            <div>
              <span style={styles.statNumber}>{internships.length}</span>
              <div style={styles.statLabel}>Open Positions</div>
            </div>
            <div>
              <span style={styles.statNumber}>
                {internships.reduce((sum, intern) => sum + intern.spots, 0)}
              </span>
              <div style={styles.statLabel}>Total Spots Available</div>
            </div>
            <div>
              <span style={styles.statNumber}>
                ${Math.round(totalStipends / internships.length / 1000)}k
              </span>
              <div style={styles.statLabel}>Average Monthly Stipend</div>
            </div>
            <div>
              <span style={styles.statNumber}>100%</span>
              <div style={styles.statLabel}>Paid Programs</div>
            </div>
          </div>
        </div>

        {/* Program Highlights */}
        <div style={styles.programHighlight}>
          <div style={{ display: "grid", gridTemplateColumns: "2fr 1fr", gap: "40px", alignItems: "center" }}>
            <div>
              <h2 style={{ fontSize: "2.5rem", fontWeight: "800", marginBottom: "1.5rem", letterSpacing: "-0.02em" }}>
                🚀 AI-Driven Innovation Program
              </h2>
              <p style={{ fontSize: "1.2rem", opacity: "0.95", marginBottom: "2rem", lineHeight: "1.7" }}>
                Join our Center of Excellence for advanced research in AI, Machine Learning, and emerging technologies. 
                Work alongside PhD researchers, publish papers, and contribute to breakthrough innovations.
              </p>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "25px" }}>
                <div>
                  <h4 style={{ fontSize: "1.1rem", fontWeight: "700", marginBottom: "15px" }}>✨ Premium Benefits</h4>
                  <ul style={{ margin: "0", paddingLeft: "20px", opacity: "0.9" }}>
                    <li>Research publication opportunities</li>
                    <li>Mentorship from industry experts</li>
                    <li>Access to advanced computing resources</li>
                    <li>Conference presentation opportunities</li>
                  </ul>
                </div>
                <div>
                  <h4 style={{ fontSize: "1.1rem", fontWeight: "700", marginBottom: "15px" }}>🎯 Research Areas</h4>
                  <ul style={{ margin: "0", paddingLeft: "20px", opacity: "0.9" }}>
                    <li>Artificial Intelligence & ML</li>
                    <li>Quantum Computing</li>
                    <li>Computer Vision & NLP</li>
                    <li>Blockchain & Web3</li>
                  </ul>
                </div>
              </div>
            </div>
            <div style={{ textAlign: "center" }}>
              <div style={{ 
                background: "rgba(255,255,255,0.2)", 
                padding: "30px", 
                borderRadius: "20px",
                backdropFilter: "blur(10px)",
                border: "1px solid rgba(255,255,255,0.3)"
              }}>
                <h3 style={{ fontSize: "3rem", marginBottom: "8px", fontWeight: "800" }}>$2.5k</h3>
                <p style={{ margin: "0", opacity: "0.9", fontSize: "1.1rem" }}>Max Monthly Stipend</p>
                <p style={{ margin: "10px 0 0 0", opacity: "0.8", fontSize: "0.9rem" }}>+ Research Bonuses</p>
              </div>
            </div>
          </div>
        </div>

        {/* Search and Filter Section */}
        <div style={styles.searchContainer}>
          <div style={{ display: "grid", gridTemplateColumns: "2fr 1fr 1fr 1fr", gap: "20px", marginBottom: "25px" }}>
            <input
              type="text"
              placeholder="🔍 Search internships, skills, or departments..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={styles.searchInput}
              onFocus={(e) => e.target.style.borderColor = "#3b82f6"}
              onBlur={(e) => e.target.style.borderColor = "#e2e8f0"}
            />
            <select
              value={selectedProgram}
              onChange={(e) => setSelectedProgram(e.target.value)}
              style={styles.filterSelect}
            >
              <option value="all">All Programs</option>
              <option value="Regular Internship">Regular Internship</option>
              <option value="AI-Driven Innovation">AI-Driven Innovation</option>
              <option value="Paid Research">Paid Research</option>
            </select>
            <select
              value={selectedDepartment}
              onChange={(e) => setSelectedDepartment(e.target.value)}
              style={styles.filterSelect}
            >
              <option value="all">All Departments</option>
              {uniqueDepartments.map(dept => (
                <option key={dept} value={dept}>{dept}</option>
              ))}
            </select>
            <select
              value={selectedLocation}
              onChange={(e) => setSelectedLocation(e.target.value)}
              style={styles.filterSelect}
            >
              <option value="all">All Locations</option>
              {uniqueLocations.map(location => (
                <option key={location} value={location}>{location}</option>
              ))}
            </select>
          </div>
          
          {/* Active Filters */}
          {(selectedProgram !== 'all' || selectedDepartment !== 'all' || selectedLocation !== 'all' || searchTerm) && (
            <div style={{ marginBottom: "20px" }}>
              <span style={{ fontWeight: "600", color: "#374151", marginRight: "15px" }}>Active Filters:</span>
              {searchTerm && <span style={styles.filterBadge}>"{searchTerm}"</span>}
              {selectedProgram !== 'all' && <span style={styles.filterBadge}>{selectedProgram}</span>}
              {selectedDepartment !== 'all' && <span style={styles.filterBadge}>{selectedDepartment}</span>}
              {selectedLocation !== 'all' && <span style={styles.filterBadge}>{selectedLocation}</span>}
              <button 
                onClick={() => {
                  setSearchTerm('');
                  setSelectedProgram('all');
                  setSelectedDepartment('all');
                  setSelectedLocation('all');
                }}
                style={{
                  background: "none",
                  border: "1px solid #d1d5db",
                  color: "#6b7280",
                  padding: "6px 12px",
                  borderRadius: "20px",
                  fontSize: "0.8rem",
                  cursor: "pointer",
                  marginLeft: "10px"
                }}
              >
                Clear All
              </button>
            </div>
          )}
          
          <div style={{ textAlign: "center", padding: "15px 0", background: "#f8fafc", borderRadius: "12px" }}>
            <p style={{ color: "#64748b", margin: "0", fontWeight: "600" }}>
              📋 Showing <span style={{ color: "#2563eb" }}>{filteredInternships.length}</span> of <span style={{ color: "#2563eb" }}>{internships.length}</span> internship opportunities
            </p>
          </div>
        </div>

        {/* Internships Grid */}
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(450px, 1fr))", gap: "30px", marginBottom: "50px" }}>
          {filteredInternships.length === 0 ? (
            <div style={{ gridColumn: "1/-1", textAlign: "center", padding: "80px 20px" }}>
              <div style={{ background: "rgba(255,255,255,0.95)", borderRadius: "24px", padding: "60px 40px", backdropFilter: "blur(20px)" }}>
                <div style={{ fontSize: "5rem", marginBottom: "25px" }}>🔍</div>
                <h3 style={{ color: "#64748b", fontSize: "1.8rem", marginBottom: "15px" }}>No internships found</h3>
                <p style={{ color: "#64748b", fontSize: "1.1rem", marginBottom: "25px" }}>
                  Try adjusting your search criteria or filters to find more opportunities
                </p>
                <button
                  onClick={() => {
                    setSearchTerm('');
                    setSelectedProgram('all');
                    setSelectedDepartment('all');
                    setSelectedLocation('all');
                  }}
                  style={{
                    background: "linear-gradient(45deg, #2563eb, #3b82f6)",
                    color: "white",
                    border: "none",
                    padding: "12px 24px",
                    borderRadius: "12px",
                    fontWeight: "600",
                    cursor: "pointer"
                  }}
                >
                  Reset Filters
                </button>
              </div>
            </div>
          ) : (
            filteredInternships.map((internship) => (
              <div 
                key={internship.id} 
                style={styles.internshipCard}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-8px)";
                  e.currentTarget.style.boxShadow = "0 25px 50px rgba(0,0,0,0.15)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "0 15px 35px rgba(0,0,0,0.1)";
                }}
              >
                <div style={styles.cardHeader}></div>
                
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "15px" }}>
                  <h3 style={styles.internshipTitle}>{internship.title}</h3>
                  <div style={{ 
                    background: internship.spots <= 3 ? "#fef2f2" : "#f0f9ff", 
                    color: internship.spots <= 3 ? "#dc2626" : "#0369a1",
                    padding: "4px 12px",
                    borderRadius: "12px",
                    fontSize: "0.8rem",
                    fontWeight: "600",
                    whiteSpace: "nowrap",
                    marginLeft: "15px"
                  }}>
                    {internship.spots <= 3 ? `⚡ ${internship.spots} spots left` : `${internship.spots} spots`}
                  </div>
                </div>

                <span style={getProgramBadgeStyle(internship.program)}>
                  {internship.program}
                </span>
                
                <div style={styles.detailsGrid}>
                  <div style={styles.detailItem}>
                    <span style={{ fontSize: "1.1rem" }}>🏢</span>
                    <span>{internship.department}</span>
                  </div>
                  <div style={styles.detailItem}>
                    <span style={{ fontSize: "1.1rem" }}>📍</span>
                    <span>{internship.location}</span>
                  </div>
                  <div style={styles.detailItem}>
                    <span style={{ fontSize: "1.1rem" }}>⏰</span>
                    <span>{internship.duration}</span>
                  </div>
                  <div style={styles.detailItem}>
                    <span style={{ fontSize: "1.1rem" }}>💰</span>
                    <span style={{ fontWeight: "700", color: "#059669" }}>{internship.stipend}</span>
                  </div>
                  <div style={styles.detailItem}>
                    <span style={{ fontSize: "1.1rem" }}>💳</span>
                    <span style={{ fontWeight: "600", color: "#10b981" }}>{internship.type}</span>
                  </div>
                  <div style={styles.detailItem}>
                    <span style={{ fontSize: "1.1rem" }}>👥</span>
                    <span>{internship.spots} positions</span>
                  </div>
                </div>
                
                <p style={{ color: "#475569", lineHeight: "1.7", marginBottom: "25px", fontSize: "1rem" }}>
                  {internship.description}
                </p>
                
                <div style={styles.skillTags}>
                  {internship.skills.map((skill, index) => (
                    <span 
                      key={index} 
                      style={{
                        ...styles.skillTag,
                        ':hover': { background: "#e2e8f0", transform: "scale(1.05)" }
                      }}
                    >
                      {skill}
                    </span>
                  ))}
                </div>
                
                <div style={{ 
                  marginBottom: "25px", 
                  padding: "20px", 
                  background: "linear-gradient(135deg, #f8fafc, #f1f5f9)", 
                  borderRadius: "16px",
                  border: "1px solid #e2e8f0"
                }}>
                  <h5 style={{ color: "#374151", fontSize: "1rem", fontWeight: "700", marginBottom: "10px" }}>
                    📋 Requirements
                  </h5>
                  <p style={{ margin: "0", color: "#64748b", fontSize: "0.9rem", lineHeight: "1.6" }}>
                    {internship.requirements}
                  </p>
                </div>
                
                <button
                  style={styles.applyBtn}
                  onClick={() => handleApply(internship)}
                  onMouseOver={(e) => {
                    e.target.style.transform = "translateY(-2px)";
                    e.target.style.boxShadow = "0 12px 30px rgba(37, 99, 235, 0.4)";
                    e.target.style.background = "linear-gradient(45deg, #1e40af, #2563eb)";
                  }}
                  onMouseOut={(e) => {
                    e.target.style.transform = "translateY(0)";
                    e.target.style.boxShadow = "0 8px 25px rgba(37, 99, 235, 0.3)";
                    e.target.style.background = "linear-gradient(45deg, #2563eb, #3b82f6)";
                  }}
                >
                  ✈️ Apply Now
                </button>
              </div>
            ))
          )}
        </div>

        {/* Application Modal */}
        {showApplicationModal && (
          <div style={styles.modal} onClick={() => setShowApplicationModal(false)}>
            <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "30px" }}>
                <h2 style={{ margin: "0", color: "#1f2937", fontSize: "2rem", fontWeight: "800" }}>Apply for Internship</h2>
                <button
                  onClick={() => setShowApplicationModal(false)}
                  style={{
                    background: "none",
                    border: "none",
                    fontSize: "2rem",
                    cursor: "pointer",
                    color: "#9ca3af",
                    padding: "5px",
                    borderRadius: "8px",
                    transition: "all 0.3s ease"
                  }}
                  onMouseOver={(e) => {
                    e.target.style.background = "#f3f4f6";
                    e.target.style.color = "#374151";
                  }}
                  onMouseOut={(e) => {
                    e.target.style.background = "none";
                    e.target.style.color = "#9ca3af";
                  }}
                >
                  ×
                </button>
              </div>
              
              <div style={{ 
                background: "linear-gradient(135deg, #f0f9ff, #e0f2fe)", 
                padding: "25px", 
                borderRadius: "16px", 
                marginBottom: "35px",
                border: "1px solid #0ea5e9"
              }}>
                <h4 style={{ color: "#0369a1", marginBottom: "8px", fontSize: "1.4rem", fontWeight: "700" }}>
                  🎯 {selectedInternship?.title}
                </h4>
                <p style={{ margin: "0", color: "#0284c7", fontSize: "1rem", fontWeight: "500" }}>
                  {selectedInternship?.department} • {selectedInternship?.location} • {selectedInternship?.stipend}
                </p>
                <div style={{ marginTop: "15px", display: "flex", gap: "10px", flexWrap: "wrap" }}>
                  {selectedInternship?.skills.slice(0, 4).map((skill, index) => (
                    <span key={index} style={{ 
                      background: "rgba(3, 105, 161, 0.1)",
                      color: "#0369a1",
                      padding: "4px 12px",
                      borderRadius: "12px",
                      fontSize: "0.8rem",
                      fontWeight: "600"
                    }}>
                      {skill}
                    </span>
                  ))}
                </div>
              </div>

              <form onSubmit={(e) => { e.preventDefault(); submitApplication(); }}>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "20px" }}>
                  <div style={styles.formGroup}>
                    <label style={styles.label}>Full Name *</label>
                    <input
                      type="text"
                      required
                      value={applicationForm.fullName}
                      onChange={(e) => handleFormChange('fullName', e.target.value)}
                      style={styles.formInput}
                      onFocus={(e) => e.target.style.borderColor = "#3b82f6"}
                      onBlur={(e) => e.target.style.borderColor = "#e5e7eb"}
                      placeholder="Enter your full name"
                    />
                  </div>

                  <div style={styles.formGroup}>
                    <label style={styles.label}>Email Address *</label>
                    <input
                      type="email"
                      required
                      value={applicationForm.email}
                      onChange={(e) => handleFormChange('email', e.target.value)}
                      style={styles.formInput}
                      onFocus={(e) => e.target.style.borderColor = "#3b82f6"}
                      onBlur={(e) => e.target.style.borderColor = "#e5e7eb"}
                      placeholder="your.email@example.com"
                    />
                  </div>
                </div>

                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "20px" }}>
                  <div style={styles.formGroup}>
                    <label style={styles.label}>Phone Number</label>
                    <input
                      type="tel"
                      value={applicationForm.phone}
                      onChange={(e) => handleFormChange('phone', e.target.value)}
                      style={styles.formInput}
                      onFocus={(e) => e.target.style.borderColor = "#3b82f6"}
                      onBlur={(e) => e.target.style.borderColor = "#e5e7eb"}
                      placeholder="+1 (555) 123-4567"
                    />
                  </div>

                  <div style={styles.formGroup}>
                    <label style={styles.label}>LinkedIn Profile</label>
                    <input
                      type="url"
                      value={applicationForm.linkedin}
                      onChange={(e) => handleFormChange('linkedin', e.target.value)}
                      style={styles.formInput}
                      onFocus={(e) => e.target.style.borderColor = "#3b82f6"}
                      onBlur={(e) => e.target.style.borderColor = "#e5e7eb"}
                      placeholder="https://linkedin.com/in/yourprofile"
                    />
                  </div>
                </div>

                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "20px" }}>
                  <div style={styles.formGroup}>
                    <label style={styles.label}>University/College</label>
                    <input
                      type="text"
                      value={applicationForm.university}
                      onChange={(e) => handleFormChange('university', e.target.value)}
                      style={styles.formInput}
                      onFocus={(e) => e.target.style.borderColor = "#3b82f6"}
                      onBlur={(e) => e.target.style.borderColor = "#e5e7eb"}
                      placeholder="Your university name"
                    />
                  </div>

                  <div style={styles.formGroup}>
                    <label style={styles.label}>Major/Field of Study</label>
                    <input
                      type="text"
                      value={applicationForm.major}
                      onChange={(e) => handleFormChange('major', e.target.value)}
                      style={styles.formInput}
                      onFocus={(e) => e.target.style.borderColor = "#3b82f6"}
                      onBlur={(e) => e.target.style.borderColor = "#e5e7eb"}
                      placeholder="Computer Science, Engineering, etc."
                    />
                  </div>
                </div>

                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "20px" }}>
                  <div style={styles.formGroup}>
                    <label style={styles.label}>Year of Study</label>
                    <select
                      value={applicationForm.yearOfStudy}
                      onChange={(e) => handleFormChange('yearOfStudy', e.target.value)}
                      style={styles.formInput}
                      onFocus={(e) => e.target.style.borderColor = "#3b82f6"}
                      onBlur={(e) => e.target.style.borderColor = "#e5e7eb"}
                    >
                      <option value="">Select your year</option>
                      <option value="1st Year">1st Year (Freshman)</option>
                      <option value="2nd Year">2nd Year (Sophomore)</option>
                      <option value="3rd Year">3rd Year (Junior)</option>
                      <option value="4th Year">4th Year (Senior)</option>
                      <option value="Graduate">Graduate Student</option>
                      <option value="PhD">PhD Candidate</option>
                      <option value="Recent Graduate">Recent Graduate</option>
                    </select>
                  </div>

                  <div style={styles.formGroup}>
                    <label style={styles.label}>GPA/CGPA (Optional)</label>
                    <input
                      type="text"
                      placeholder="3.8/4.0 or 8.5/10"
                      value={applicationForm.gpa}
                      onChange={(e) => handleFormChange('gpa', e.target.value)}
                      style={styles.formInput}
                      onFocus={(e) => e.target.style.borderColor = "#3b82f6"}
                      onBlur={(e) => e.target.style.borderColor = "#e5e7eb"}
                    />
                  </div>
                </div>

                <div style={styles.formGroup}>
                  <label style={styles.label}>Portfolio/GitHub URL</label>
                  <input
                    type="url"
                    placeholder="https://github.com/username or your portfolio website"
                    value={applicationForm.portfolio}
                    onChange={(e) => handleFormChange('portfolio', e.target.value)}
                    style={styles.formInput}
                    onFocus={(e) => e.target.style.borderColor = "#3b82f6"}
                    onBlur={(e) => e.target.style.borderColor = "#e5e7eb"}
                  />
                </div>

                <div style={styles.formGroup}>
                  <label style={styles.label}>Relevant Skills & Technologies</label>
                  <input
                    type="text"
                    placeholder="e.g., Python, React, Machine Learning, Data Analysis"
                    value={applicationForm.skills}
                    onChange={(e) => handleFormChange('skills', e.target.value)}
                    style={styles.formInput}
                    onFocus={(e) => e.target.style.borderColor = "#3b82f6"}
                    onBlur={(e) => e.target.style.borderColor = "#e5e7eb"}
                  />
                </div>

                <div style={styles.formGroup}>
                  <label style={styles.label}>Previous Experience (Optional)</label>
                  <textarea
                    placeholder="Briefly describe any relevant work experience, projects, or internships..."
                    value={applicationForm.experience}
                    onChange={(e) => handleFormChange('experience', e.target.value)}
                    style={styles.textarea}
                    onFocus={(e) => e.target.style.borderColor = "#3b82f6"}
                    onBlur={(e) => e.target.style.borderColor = "#e5e7eb"}
                  />
                </div>

                <div style={styles.formGroup}>
                  <label style={styles.label}>Cover Letter *</label>
                  <textarea
                    required
                    placeholder="Tell us why you're interested in this position, what makes you a great fit, and what you hope to learn..."
                    value={applicationForm.coverLetter}
                    onChange={(e) => handleFormChange('coverLetter', e.target.value)}
                    style={{ ...styles.textarea, minHeight: "150px" }}
                    onFocus={(e) => e.target.style.borderColor = "#3b82f6"}
                    onBlur={(e) => e.target.style.borderColor = "#e5e7eb"}
                  />
                </div>

                <div style={styles.formGroup}>
                  <label style={styles.label}>Resume/CV</label>
                  <input
                    type="file"
                    accept=".pdf,.doc,.docx"
                    onChange={(e) => handleFormChange('resume', e.target.files[0])}
                    style={{ ...styles.formInput, padding: "12px" }}
                  />
                  <small style={{ color: "#6b7280", fontSize: "0.85rem", marginTop: "8px", display: "block" }}>
                    📎 Accepted formats: PDF, DOC, DOCX (Max 5MB)
                  </small>
                </div>

                <div style={{ display: "grid", gridTemplateColumns: "1fr 2fr", gap: "20px", marginTop: "40px" }}>
                  <button
                    type="button"
                    onClick={() => setShowApplicationModal(false)}
                    style={styles.cancelBtn}
                    onMouseOver={(e) => e.target.style.background = "#e5e7eb"}
                    onMouseOut={(e) => e.target.style.background = "#f3f4f6"}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    style={styles.submitBtn}
                    onMouseOver={(e) => {
                      e.target.style.background = "linear-gradient(45deg, #059669, #047857)";
                      e.target.style.transform = "translateY(-2px)";
                    }}
                    onMouseOut={(e) => {
                      e.target.style.background = "linear-gradient(45deg, #10b981, #059669)";
                      e.target.style.transform = "translateY(0)";
                    }}
                  >
                    🚀 Submit Application
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}

        {/* Footer Section */}
        <div style={{
          background: "rgba(255,255,255,0.95)",
          backdropFilter: "blur(20px)",
          borderRadius: "24px",
          padding: "50px 40px",
          marginTop: "50px",
          textAlign: "center",
          border: "1px solid rgba(255,255,255,0.2)"
        }}>
          <h3 style={{ fontSize: "2rem", fontWeight: "700", color: "#1f2937", marginBottom: "20px" }}>
            Ready to Start Your Journey? 🌟
          </h3>
          <p style={{ fontSize: "1.1rem", color: "#64748b", maxWidth: "600px", margin: "0 auto 30px auto", lineHeight: "1.7" }}>
            Join thousands of students who have launched their careers through our internship programs. 
            Apply today and be part of the next generation of innovators!
          </p>
          <div style={{ display: "flex", justifyContent: "center", gap: "30px", flexWrap: "wrap" }}>
            <div style={{ textAlign: "center" }}>
              <div style={{ fontSize: "2.5rem", marginBottom: "10px" }}>💼</div>
              <p style={{ color: "#374151", fontWeight: "600", margin: "0" }}>Career Growth</p>
            </div>
            <div style={{ textAlign: "center" }}>
              <div style={{ fontSize: "2.5rem", marginBottom: "10px" }}>🤝</div>
              <p style={{ color: "#374151", fontWeight: "600", margin: "0" }}>Mentorship</p>
            </div>
            <div style={{ textAlign: "center" }}>
              <div style={{ fontSize: "2.5rem", marginBottom: "10px" }}>🔬</div>
              <p style={{ color: "#374151", fontWeight: "600", margin: "0" }}>Research</p>
            </div>
            <div style={{ textAlign: "center" }}>
              <div style={{ fontSize: "2.5rem", marginBottom: "10px" }}>🏆</div>
              <p style={{ color: "#374151", fontWeight: "600", margin: "0" }}>Recognition</p>
            </div>
          </div>
<Link 
  to="/internship_form" 
  className="btn btn-success rounded-2 justify-content-center fw-bold text-center w-auto d-flex mx-auto mt-3 mb-2 p-3"
>
  Submit Internship Form
</Link>        </div>
      </div>

      {/* Add custom CSS for animations */}
      <style jsx>{`
        @keyframes slideIn {
          from {
            opacity: 0;
            transform: translateX(100%);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }
        
        /* Responsive design */
        @media (max-width: 768px) {
          .hero-title {
            font-size: 2.5rem !important;
          }
          .hero-subtitle {
            font-size: 1.1rem !important;
          }
          .program-highlight {
            grid-template-columns: 1fr !important;
          }
          .search-filters {
            grid-template-columns: 1fr !important;
            gap: 15px !important;
          }
          .internships-grid {
            grid-template-columns: 1fr !important;
          }
          .modal-content {
            padding: 30px 20px !important;
            margin: 10px !important;
          }
          .form-grid {
            grid-template-columns: 1fr !important;
          }
        }
      `}</style>
    </div>
  );
};

export default InternshipsPage;